import { HISTORY_TYPES, IHistoryItem } from 'types/History';
import { ThunkApiType } from 'types/storeTypes';
import authFetch, { checkForUnauthorizedResponse } from 'utils/axios';

export const getHistoryThunk = async (
	{
		historyType,
		uuid,
	}: { historyType: keyof typeof HISTORY_TYPES; uuid: string },
	thunkAPI: ThunkApiType,
): Promise<IHistoryItem[]> => {
	const historyURL = `/${historyType}/${uuid}/history`;

	try {
		const response = await authFetch.get(historyURL);

		const { data } = response;
		return data.claimHistory;
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};
